export class UserAcl {
    acl = '-';
    active = false;

    constructor(acl: string, active: boolean) {
        this.acl = acl;
        this.active = active;
    }
}
